import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "text-edit-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor" },
        React.createElement("rect", { width: 2, height: 2, x: 1.5, y: 7.5, rx: 1 }),
        React.createElement("rect", { width: 2, height: 2, x: 13.5, y: 7.5, rx: 1 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m5.5 12.5 2.526-7.577a.5.5 0 0 1 .948 0L11.5 12.5" }),
        React.createElement("path", { d: "M6.5 10h4" }),
        React.createElement("path", { strokeLinecap: "round", d: "M14.5 11.5v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2m0-6v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
